"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDayPicker = require("react-day-picker");
var _chevronLeft = _interopRequireDefault(require("@spothero/icons/chevron-left"));
var _chevronRight = _interopRequireDefault(require("@spothero/icons/chevron-right"));
var _Button = _interopRequireDefault(require("../v1/components/Button/Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DatePickerCalendarNavigation extends _react.Component {
  _onPreviousClick = () => {
    this.props.onPreviousClick();
  };
  _onNextClick = () => {
    this.props.onNextClick();
  };
  render() {
    const {
      className,
      showPreviousButton,
      showNextButton
    } = this.props;
    const classes = (0, _classnames.default)('DatePickerCalendarNavigation', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, showPreviousButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "DayPicker-NavButton DayPicker-NavButton--prev",
      onClick: this._onPreviousClick
    }, /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null)), showNextButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "DayPicker-NavButton DayPicker-NavButton--next",
      onClick: this._onNextClick
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null)));
  }
}
exports.default = DatePickerCalendarNavigation;